__turbopack_context__.v({
  "account-dropdown-button": "UtilityLinks-module-scss-module__tN1NnW__account-dropdown-button",
  "account-links": "UtilityLinks-module-scss-module__tN1NnW__account-links",
  "container": "UtilityLinks-module-scss-module__tN1NnW__container",
  "desktop": "UtilityLinks-module-scss-module__tN1NnW__desktop",
  "find-links": "UtilityLinks-module-scss-module__tN1NnW__find-links",
  "knowledge-center": "UtilityLinks-module-scss-module__tN1NnW__knowledge-center",
  "link": "UtilityLinks-module-scss-module__tN1NnW__link",
  "locale-dropdown": "UtilityLinks-module-scss-module__tN1NnW__locale-dropdown",
  "locale-dropdown-button": "UtilityLinks-module-scss-module__tN1NnW__locale-dropdown-button",
  "locale-image": "UtilityLinks-module-scss-module__tN1NnW__locale-image",
  "mobile": "UtilityLinks-module-scss-module__tN1NnW__mobile",
  "mobile-centered": "UtilityLinks-module-scss-module__tN1NnW__mobile-centered",
  "utility-links": "UtilityLinks-module-scss-module__tN1NnW__utility-links",
});
